module.exports = __webpack_public_path__ + "img/detail7.ea687e33.png";